import { parseInt } from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import AutoRepliesGql from '@/extensions/communication/store/graphql/queries/AutoReplies.gql';
import SaveAutoReplyGql from '@/extensions/communication/store/graphql/mutations/SaveAutoReply.gql';
import { sanitizeHeaderImageInput } from '@/extensions/communication/utils/headerImageInput';

export default {
    fetchList: cmsID =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({ query: AutoRepliesGql, variables: { cms_id: parseInt(cmsID) }, fetchPolicy: 'network-only' })
                .then(({ data }) => resolve(data.EX_COMM_AutoReplies))
                .catch(err => reject(err));
        }),

    save: (cmsID, config) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveAutoReplyGql,
                    variables: {
                        cms_id: parseInt(cmsID),
                        channel: config.channel,
                        enabled: !!config.enabled,
                        message: config.message,
                        // Optional custom subject (email only); blank → "Re: <thread subject>" on send.
                        subject: (config.channel === 'email' && config.subject) ? config.subject : null,
                        cooldown_minutes: parseInt(config.cooldown_minutes) || 0,
                        // WhatsApp interactive chrome (header/footer/buttons); email leaves these unset.
                        header_format: (config.interactive && config.interactive.header_format) || 'NONE',
                        header: (config.interactive && config.interactive.header) || null,
                        header_media_url: (config.interactive && config.interactive.header_media_url) || null,
                        headerImage: sanitizeHeaderImageInput(config.interactive && config.interactive.header_image),
                        footer: (config.interactive && config.interactive.footer) || null,
                        buttons: ((config.interactive && config.interactive.buttons) || []).map(button => ({
                            type: button.type,
                            text: button.text,
                            url: button.url || null,
                            phone_number: button.phone_number || null
                        }))
                    }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_COMM_SaveAutoReply);
                })
                .catch(err => reject(err));
        })
};
